import moment from "moment";

/**
 * checks if the contract is active based on the start and end date
 * @param start The start date of the contract.
 * @param end The end date of the contract.
 * @returns A boolean indicating whether the contract is currently active.
 */
export const isContractActive = (start: string, end: string): boolean =>
  moment(new Date()).isBetween(start, end);
